import { render } from "./ContactAddressDialog.vue?vue&type=template&id=e1a3e536"
import script from "./ContactAddressDialog.vue?vue&type=script&lang=js"
export * from "./ContactAddressDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__